import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"
import { UpdateOrderGoodsPaylod, UpdateOrderGoodsResponseData } from "../types/order"

const patchData = async (uuid: string | undefined, payload: UpdateOrderGoodsPaylod) => {
    const { data } = await api.patch<UpdateOrderGoodsResponseData>(
        `/orders/${uuid}`,
        payload
    )

    queryClient.invalidateQueries(queryKeys.ORDER(uuid))
    queryClient.invalidateQueries(queryKeys.ORDER_SUMMARY(uuid), { refetchInactive: true })
    queryClient.invalidateQueries(["orders"], { refetchInactive: true })

    return data
}

export const useUpdateGoods = (uuid: string | undefined) => {
    return useMutation((payload: UpdateOrderGoodsPaylod) => {
        return patchData(uuid, payload)
    })
}
